/* eslint-disable jsx-a11y/no-access-key */
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TinyEditor from '../../../TinyEditor'
import config from '../../../../config'
import { FormControl, Input, useTheme } from '@material-ui/core'
import {
  checkTextSize,
  convertLanguagesToFull,
  isObjectEmpty,
  isObjectsEqual,
  stripHtml,
  wordCount
} from '../../../../utils'
import { Check, Edit, Refresh } from '@material-ui/icons'
import ComponentWithPop from '../../../common/ComponentWithPop'
import { useActions } from '../../../../utils/action-helper'
import {
  analyseSetEnabledBenchmark,
  analyseSetLocalResult,
  analyseSetResult,
  analyseSetText,
  analyseSetTextLanguage
} from '../../../../actions'
import { useSelector } from 'react-redux'
import { filterBenchmark, startAnalyse } from '../../analysisFunctions'
import TLServiceComponent from '../../../../contexts/TLServiceComponent'
import { Redirect } from 'react-router-dom'
import TopIndicatorsBarAi from '../../TopIndicatorsBar/TopIndicatorsBarAI'
import CloseIcon from '@material-ui/icons/Close'
import Tonality from './TonalityAi.jsx'
import LanaguageLevel from './LangugageLevel.jsx'
import undoBtn from '../assets/undo.png'
import undoBtnWhite from '../assets/undo-white.png'
import undoBtnInactive from '../assets/undo-inactive.png'
import redoBtnWhite from '../assets/redo-white.png'
import redoBtn from '../assets/redo.png'
import redoBtnInactive from '../assets/redo-inactive.png'
import comBotWhite from '../../../../assets/combot-white.svg'
import RightSection from './RightSection'

const GeneratorResult = ({
  message,
  benchmarkSelectWrapperRef,
  promptValues,
  benchmarkList,
  useBenchmarkList,
  currentCard,
  handleTextTypeChange,
  handleOurAi,
  translatedText,
  setTranslatedText,
  shouldAnalyse,
  setShouldAnalyse,
  setError,
  setSubmitted,
  promptForOptimization,
  setPromptForOptimization,
  setPromptValues,
  newPromptOpen,
  setNewPromptOpen

}) => {
  const tlService = useContext(TLServiceComponent)
  const { t, i18n: { language: i18nLanguage } } = useTranslation()
  const { theme: { bgColors, colors, borderColors } } = useTheme()
  const {
    actionAnalyseSetTextLanguage,
    actionAnalyseSetEnabledBenchmark,
    actionAnalyseSetResult,
    actionAnalyseSetText,
    aAnalyseSetLocalResult,
  } = useActions({
    actionAnalyseSetTextLanguage: analyseSetTextLanguage,
    actionAnalyseSetEnabledBenchmark: analyseSetEnabledBenchmark,
    aAnalyseSetLocalResult: analyseSetLocalResult,
    actionAnalyseSetText: analyseSetText,
    actionAnalyseSetResult: analyseSetResult
  })
  const enabledBenchmarks = useSelector(state => state.analyseData.enabledBenchmarks)
  const benchmarks = useSelector(state => state.userData.benchmarks)
  const textLanguage = useSelector(state => state.analyseData.textLanguage)

  const reduxCurrentBenchmarkSettings = useSelector(state => state.analyseData.result.benchmark)
  const localResult = useSelector(state => state.analyseData.result.localAnalyseResultData)
  const token = useSelector(state => state.userData.token)
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isWhite = themeState === config.THEMES_MODES.CONTRAST_LIGHT


  const [localBenchmark, setLocalBenchmark] = useState(reduxCurrentBenchmarkSettings)
  const [analyseButtonEnable, setAnalyseButtonEnable] = useState(false)
  const [editor, setEditor] = useState(null)
  const [enableButtonBack, setEnableButtonBack] = useState(false)
  const [showBar, setShowBar] = useState(false)
  const [localAnalyseResult, setLocalAnalyseResult] = useState({})
  const [newPrompt, setNewPrompt] = useState(message)
  const [redirect, setRedirect] = useState('')

  const regEmpty = /\w/
  const showRefreshButton = localResult['formulaHix'] !== undefined || localResult['formulaFlesch'] !== undefined || localResult['formulaCLIX'] !== undefined

  const undoIcon = themeState === config.THEMES_MODES.CONTRAST_DARK ? undoBtnWhite : undoBtn
  const redoIcon = themeState === config.THEMES_MODES.CONTRAST_DARK ? redoBtnWhite : redoBtn

  useEffect(() => {

    if (useBenchmarkList > -1 && !isObjectEmpty(benchmarks)) {
      actionAnalyseSetTextLanguage(benchmarks[benchmarkList[useBenchmarkList].id]?.locale_name || convertLanguagesToFull(i18nLanguage))
    }

    if (regEmpty.test(translatedText)) {
      setEnableButtonBack(true)
    } else {
      setEnableButtonBack(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benchmarks, textLanguage, translatedText, useBenchmarkList])

  useEffect(() => {
    if (!newPrompt.length > 0 || useBenchmarkList === -1) {
      setAnalyseButtonEnable(false)
    } else {
      setAnalyseButtonEnable(true)
    }
  }, [newPrompt.length, useBenchmarkList, promptValues?.tonality, promptValues?.text_length])

  useEffect(() => {
    if (!isObjectEmpty(benchmarks)) {
      const filteredBenchmark = filterBenchmark(benchmarks, textLanguage, 'locale_name')
      if (!isObjectsEqual(filteredBenchmark, enabledBenchmarks)) {
        actionAnalyseSetEnabledBenchmark(filteredBenchmark)
      }
    }
    // eslint-disable-next-line
  }, [benchmarks, textLanguage])

  useEffect(() => {
    handleOurAi(message)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const runLocalAnalyse = async () => {
      if (shouldAnalyse) {
        await localAnalyse()
        setShouldAnalyse(false)
      }
    }
    runLocalAnalyse()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldAnalyse])

  function handleOnEditorInit (event, newEditor) {
    setEditor(newEditor)
  }

  const handleOnEditorChange = (newText) => {
    newText = newText.replace(/\xAD/g, '')
    setTranslatedText(newText)
  }

  const localAnalyse = async () => {

    const selectedBenchmark = benchmarkList[useBenchmarkList]?.id
    let localTextLanguage, localBenchmark
    if (selectedBenchmark) {
      localTextLanguage = benchmarks[selectedBenchmark]?.locale_name
      localBenchmark = selectedBenchmark
    } else {
      return false
    }

    const checkedSizeError = checkTextSize(config, translatedText.length, stripHtml(translatedText).length)
    if (checkedSizeError) {
      setError({ text: t(checkedSizeError), header: t(checkedSizeError) })
      return false
    }
    let result
    try {
      result = await startAnalyse(localBenchmark, localTextLanguage, translatedText,
        tlService, token, t)
    } catch (e) {
      console.log('error', e)
      return false
    }
    if (result.error) {
      setError(result.error)
      setSubmitted(false)
      return false
    }
    aAnalyseSetLocalResult(result.resultData)
    setLocalBenchmark(benchmarks[result.resultTemplate])
    setLocalAnalyseResult(result)
    setSubmitted(false)
    setShowBar(true)
  }

  const handleSendBack = () => {
    actionAnalyseSetText(translatedText)
    actionAnalyseSetResult(localAnalyseResult.resultData, localAnalyseResult.resultTemplate,
      benchmarks[localAnalyseResult.resultTemplate])
    setRedirect('/')
  }
  const handleRefreshAnalyse = () => {
    localAnalyse()
  }

  if (redirect) {
    return <Redirect to={redirect}/>
  }

  return (

      <div className="p-3 pt-1 mt-1 mb-1" style={{
        borderRadius: '10px',
        backgroundColor: bgColors.bgPrimary0,
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.161)'
      }}>
        <div className="d-flex align-items-center mb-2" style={{ maxWidth: '65%' }}>
          <div
            className="d-flex align-items-center justify-content-center p-2"
            style={{
              height: '40px',
              borderRadius: '5px',
              marginRight: '10px',
              filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
              backgroundColor: bgColors.bgAiBtn,
              cursor: 'pointer',
            }}
            onClick={() => { setNewPromptOpen(prev => !prev) }}
            tabIndex={config.tabIndexes.genResultInputFieldBtn} title={t('accessibility_gen_edit_prompt')}
          >
            <Edit style={{ color: isWhite ? colors.colorWhite : colors.colorIcons }}/>
            <p className="mt-3 ml-2" style={{ color: isWhite ? colors.colorWhite : colors.colorText }}>
              {t('ai_gen_edit_prompt')}
            </p>
          </div>
          <p className="m-0" style={{
            fontSize: '0.95rem',
            fontWeight: 'bold',
            color: colors.colorPrimary500,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {newPrompt.length > 0 ? newPrompt : t('ai_gen_your-text')}
          </p>
        </div>
        <div className="row d-flex flex-lg-row" style={{ height: '80vh', borderRadius: '8px' }}>
          <div className="col-lg-8 mb-4 mb-lg-0 d-flex flex-column" style={{ height: '100%' }}>
            <div className="p-2 d-flex flex-column " style={{
              border: `1px solid ${borderColors.borderPrimary100}`,
              height: '100%',
              borderRadius: '8px',
              position: 'relative'
            }}>
              {newPromptOpen && (
                <FormControl fullWidth style={{
                  borderBottom: `1px solid ${borderColors.borderPrimary100}`,
                  backgroundColor: bgColors.bgPrimary200,
                  borderRadius: '7px',
                  padding: '0 10px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  position: 'absolute',
                  top: '-50px',
                  zIndex: 9999,
                  width: '83%',
                  right: 0
                }}>
                  <Input
                    placeholder={t('ai_gen_type-your-message')}
                    multiline
                    rows="8"
                    value={newPrompt}
                    onChange={(e) => {
                      setNewPrompt(e.target.value)
                    }}
                    inputProps={{
                      tabIndex: config.tabIndexes.genInputField,
                      style: { fontSize: '0.95rem', color: colors.colorText, padding: '10px 0' }
                    }}
                    disableUnderline
                    style={{ position: 'relative' }}
                  />
                  <div className="d-flex justify-content-end mt-2">
                    <button
                      className="btn d-flex align-items-center justify-content-center"
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        backgroundColor: bgColors.bgPrimary300,
                        border: 'none',
                        cursor: 'pointer',
                        outline: 'none',
                        boxShadow: 'none'
                      }}
                      onClick={() => { setNewPromptOpen(prev => !prev) }}
                      tabIndex={config.tabIndexes.genResultInputFieldClose}
                    >
                      <CloseIcon style={{ color: colors.colorPrimary0, fontSize: 14 }}/>
                    </button>
                  </div>
                </FormControl>
              )}
              {
                showBar && !isObjectEmpty(localResult) && (
                  <div className="position-relative" style={{ position: 'relative' }}>
                    <div className="d-flex p-2 flex-wrap">
                      <TopIndicatorsBarAi
                        extResultData={localResult}
                        extCurrentBenchmarkSettings={localBenchmark}
                        gen
                      />

                      {Object.keys(config.tonalityParameters).filter(v => localResult[v] !== undefined).length > 0 && (
                        <Tonality resultData={localResult} tabIndex={config.tabIndexes.genTonalityWrapper}/>
                      )}

                      {localResult.formulaLanguageLevel > -1 && (
                        <LanaguageLevel resultData={localResult} tabIndex={config.tabIndexes.genLanguageWrapper}/>
                      )}
                      {showRefreshButton && (
                        <div
                          style={{
                            maxHeight: '2em',
                            marginLeft: '15px',
                            backgroundColor: bgColors.bgPrimary100,
                            borderRadius: '5px',
                            filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
                          }}
                          className="d-flex align-items-center justify-content-center"
                          onClick={handleRefreshAnalyse}
                          tabIndex={config.tabIndexes.genRefreshButton}
                          title={t('accessibility_analysis_refresh')}
                        >
                          <Refresh
                            style={{
                              padding: 5,
                              cursor: 'pointer',
                              color: colors.colorText,
                              fontSize: 30,
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 10,
                        right: 10,
                        zIndex: 2,
                      }}
                      accessKey={config.accessKeys.aiAcceptRight}
                      onClick={handleSendBack}
                      tabIndex={enableButtonBack ? config.tabIndexes.genAcceptTextButton : -1}
                    >
                      <ComponentWithPop text={`${t('ai_accept_text')}`}>
                        <button
                          disabled={!enableButtonBack}
                          style={{
                            backgroundColor: enableButtonBack ? bgColors.bgPrimary200 : bgColors.bgPrimary400,
                            padding: 1
                          }}
                          className="d-flex align-items-center p-1"
                          aria-label={t('ai_accept_text')}
                        >
                          <Check
                            style={{
                              cursor: enableButtonBack ? 'pointer' : 'inherit',
                              stroke: enableButtonBack ? colors.colorProgress100 : bgColors.bgPrimary0,
                              strokeWidth: 2
                            }}
                            fontSize="medium"
                          />
                        </button>
                      </ComponentWithPop>
                    </div>
                  </div>
                )
              }
              <div className="position-relative" style={{ height: '90%' }}>
                <TinyEditor
                  initialValue=""
                  text={translatedText}
                  editorId="second"
                  handleOnSelectorChange={() => { }}
                  handleOnEditorKeyUp={() => { }}
                  handleOnEditorInit={handleOnEditorInit}
                  handleOnEditorChange={handleOnEditorChange}
                  handleOnMouseOver={() => { }}
                  handleOnMouseClick={() => { }}
                  height="100%"
                  fromAI={true}
                  shortcutKey={config.accessKeys.editor.toLowerCase()}
                />
              </div>
              <div className="d-flex justify-content-between mt-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div style={{
                    borderRadius: '5px',
                    padding: '5px 10px',
                    filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
                    backgroundColor: bgColors.bgPlainBtn,
                  }}>
                    <img
                      style={{
                        cursor: 'pointer',
                        marginRight: 10,
                        width: 20,
                        height: 25,
                      }}
                      onClick={() => {
                        if (editor) {
                          editor.undoManager.undo()
                        }
                      }}
                      title={t('accessibility_analysis_undo')}
                      src={editor?.undoManager?.hasUndo() ? undoIcon : undoBtnInactive}
                      alt="undo"
                    />
                    <span style={{ borderLeft: '1px solid #817d7d', height: '30px', marginRight: 10 }}></span>
                    <img
                      style={{
                        cursor: 'pointer',
                        marginRight: 10,
                        width: 20,
                        height: 25,
                      }}
                      onClick={() => {
                        if (editor) {
                          editor.undoManager.redo()
                        }
                      }}
                      title={t('accessibility_analysis_redo')}
                      src={editor?.undoManager?.hasRedo() ? redoIcon : redoBtnInactive}
                      alt="redo"
                    />
                  </div>
                  <div title={t('accessibility_word_count')} className="ml-3" style={{ color: colors.colorMutedText }}>
                    <span>{t('Words')}:</span> <b>{wordCount(translatedText) || 0}</b></div>
                </div>
                <div
                  onClick={() => { handleOurAi(newPrompt) }}
                  tabIndex={config.tabIndexes.genButton}
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  accessKey={config.accessKeys.runAnalyse}
                >
                  <button disabled={!analyseButtonEnable}
                          className="btn d-flex align-items-center justify-content-center"
                          title={t('ai_gen_variant_erstelle')} style={{
                    backgroundColor: bgColors.bgProgress100,
                    color: colors.colorBtnText,
                    border: `1px solid ${borderColors.borderPrimary200}`
                  }}>
                    <img style={{ marginRight: 4 }} src={comBotWhite} alt="" width="30px"/>
                    {t('ai_gen_variant_erstelle')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Right Section */}
          <RightSection
            benchmarkSelectWrapperRef={benchmarkSelectWrapperRef}
            benchmarkList={benchmarkList}
            useBenchmarkList={useBenchmarkList}
            currentCard={currentCard}
            handleTextTypeChange={handleTextTypeChange}
            translatedText={translatedText}
            promptForOptimization={promptForOptimization}
            setPromptForOptimization={setPromptForOptimization}
            setPromptValues={setPromptValues}
            promptValues={promptValues}
            handleOurAi={handleOurAi}
          />
        </div>
      </div>
  )
}

export default GeneratorResult